var _g, _rect, _path, _path2, _rect2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddNft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 214,
    viewBox: "0 0 196 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_28_1726)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.9998,
    y: 13.2251,
    width: 144.403,
    height: 162.251,
    rx: 8.99338,
    fill: "url(#paint0_linear_28_1726)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4739,
    y: 12.6993,
    width: 145.455,
    height: 163.303,
    rx: 9.51922,
    stroke: "url(#paint1_linear_28_1726)",
    strokeWidth: 1.05167,
    shapeRendering: "crispEdges"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.2679,
    y: 74.5973,
    width: 23.0562,
    height: 23.0562,
    rx: 11.5281,
    fill: "#15121D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.1172 85.8931H103.01",
    stroke: "white",
    strokeWidth: 1.28148,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6772 80.4468L97.6772 91.3393",
    stroke: "white",
    strokeWidth: 1.28148,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.2679,
    y: 74.5973,
    width: 23.0562,
    height: 23.0562,
    rx: 11.5281,
    stroke: "#15121D",
    strokeWidth: 1.28148
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5441 117.351H93.9297L90.7723 109.287H89.4435L86.2975 117.351H87.6831L88.3077 115.704H91.9195L92.5441 117.351ZM88.7507 114.511L90.1136 110.899L91.4765 114.511H88.7507ZM98.806 109.287V112.387H98.7833C98.5675 111.922 97.8179 111.331 96.739 111.331C95.342 111.331 93.8769 112.365 93.8769 114.398C93.8769 116.431 95.342 117.464 96.739 117.464C97.8179 117.464 98.5675 116.874 98.7833 116.408H98.8174V117.351H100.067V109.287H98.806ZM96.9775 116.328C96.0348 116.328 95.1148 115.67 95.1148 114.398C95.1148 113.126 96.0348 112.467 96.9775 112.467C97.9315 112.467 98.8515 113.126 98.8515 114.398C98.8515 115.67 97.9315 116.328 96.9775 116.328ZM105.96 109.287V112.387H105.937C105.721 111.922 104.972 111.331 103.893 111.331C102.496 111.331 101.031 112.365 101.031 114.398C101.031 116.431 102.496 117.464 103.893 117.464C104.972 117.464 105.721 116.874 105.937 116.408H105.971V117.351H107.221V109.287H105.96ZM104.131 116.328C103.189 116.328 102.269 115.67 102.269 114.398C102.269 113.126 103.189 112.467 104.131 112.467C105.085 112.467 106.005 113.126 106.005 114.398C106.005 115.67 105.085 116.328 104.131 116.328Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_28_1726",
    x: -26.2877,
    y: -39.0624,
    width: 248.978,
    height: 266.826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 25.6179
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_28_1726"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.1688
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.1688
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_28_1726",
    result: "effect2_dropShadow_28_1726"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_28_1726",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_1726",
    x1: 27.7486,
    y1: 17.4455,
    x2: 202.787,
    y2: 72.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_1726",
    x1: 30.2243,
    y1: 93.2689,
    x2: 170.403,
    y2: 93.2689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490109,
    stopColor: "#C71EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A27EA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNft);
export default __webpack_public_path__ + "static/media/addNft.8e7c8bf3efe78f0cbb9ff90b5e73aace.svg";
export { ForwardRef as ReactComponent };